var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "80px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.MappingType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              headers: [
                                _vm.$t("SystemMaintenance.Description")
                              ],
                              fields: ["typeDesc"],
                              "callback-params": { key: "type" },
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.type,
                              "tag-value": "typeCode",
                              "tag-name": "typeDesc",
                              "filter-tag-names": ["typeDesc"],
                              "static-options": _vm.mappingTypeList
                            },
                            on: {
                              parentCallBack: function($event) {
                                return _vm.getValueFromChild(
                                  _vm.searchConditions,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.Condition")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.static_data_Company,
                              "callback-params": { key: "condition1" },
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.condition1,
                              "static-options": _vm.companyList
                            },
                            on: {
                              parentCallBack: function($event) {
                                return _vm.getValueFromChild(
                                  _vm.searchConditions,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.SendingPlatform")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "callback-params": { key: "sendingPlatform" },
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.sendingPlatform,
                              "static-options": _vm.sendingPlatformList,
                              "tag-name": "chineseName",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function($event) {
                                return _vm.getValueFromChild(
                                  _vm.searchConditions,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _vm.currentOfficeId !== 1
                            ? _c(
                                "el-checkbox",
                                {
                                  on: { change: _vm.onViewHQMappingChange },
                                  model: {
                                    value: _vm.isViewHQMapping,
                                    callback: function($$v) {
                                      _vm.isViewHQMapping = $$v
                                    },
                                    expression: "isViewHQMapping"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.ViewHQMapping")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.toQuery }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.btn.query")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.popMappingAddDialog }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.popMappingEditFormDialog }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "mini" },
                  on: { click: _vm.toBatchDel }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")) + " ")]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "config-module": "20220821",
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              },
              on: { gridReady: _vm.onReady }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "20220821",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.fetchData
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowDialogForm,
            title: _vm.dialogTitle,
            "inline-message": "",
            width: "405px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDialogForm = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "mappingForm",
              attrs: {
                model: _vm.mappingForm,
                "label-width": "120px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.MappingType") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "205px" },
                    attrs: {
                      filterable: "",
                      headers: [_vm.$t("SystemMaintenance.Description")],
                      fields: ["typeDesc"],
                      "callback-params": { key: "type" },
                      "callback-method-type": "value",
                      "default-value": _vm.mappingForm.type,
                      "tag-value": "typeCode",
                      "tag-name": "typeDesc",
                      "filter-tag-names": ["typeDesc"],
                      "static-options": _vm.mappingTypeList
                    },
                    on: {
                      parentCallBack: function($event) {
                        return _vm.getValueFromChild(_vm.mappingForm, $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.Condition") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "205px" },
                    attrs: {
                      filterable: "",
                      headers: [
                        _vm.$t("SystemMaintenance.EnglishName2"),
                        _vm.$t("SystemMaintenance.ChineseName2")
                      ],
                      fields: ["englishName", "chineseName"],
                      "callback-params": { key: "condition1" },
                      "callback-method-type": "value",
                      "default-value": _vm.mappingForm.condition1 || "",
                      "tag-value": "cmpIdx",
                      "tag-name": "chineseName",
                      "filter-tag-names": [
                        "englishName",
                        "chineseName",
                        "code"
                      ],
                      "static-options": _vm.companyList
                    },
                    on: {
                      parentCallBack: function($event) {
                        return _vm.getValueFromChild(_vm.mappingForm, $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SystemMaintenance.SendingPlatform") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "205px" },
                    attrs: {
                      filterable: "",
                      multiple: true,
                      placeholder: " ",
                      "callback-method-type": "value",
                      "static-options": _vm.sendingPlatformList,
                      "default-multiple-value":
                        _vm.mappingForm.sendingPlatformList,
                      "tag-name": "chineseName",
                      "tag-value": "code"
                    },
                    on: {
                      parentCallBack: function(value) {
                        return (_vm.mappingForm.sendingPlatformList = [].concat(
                          value
                        ))
                      }
                    }
                  })
                ],
                1
              ),
              _vm.mappingForm.type === "BOOKING_STATUS"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierShip") } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.mappingForm.carrier,
                          callback: function($$v) {
                            _vm.$set(_vm.mappingForm, "carrier", $$v)
                          },
                          expression: "mappingForm.carrier"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.OriginalValue") } },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.mappingForm.sourceValue,
                      callback: function($$v) {
                        _vm.$set(_vm.mappingForm, "sourceValue", $$v)
                      },
                      expression: "mappingForm.sourceValue"
                    }
                  })
                ],
                1
              ),
              _vm.mappingForm.type === "BOOKING_STATUS"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.NewValue") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "static-options":
                            _vm.SystemConstants.JOB_BOOKING_STATES_NEW,
                          "default-value": !!_vm.mappingForm.targetValue
                            ? Number(_vm.mappingForm.targetValue)
                            : 0,
                          "tag-name": "chineseName",
                          "tag-value": "code"
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.mappingForm.targetValue = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.NewValue") } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.mappingForm.targetValue,
                          callback: function($$v) {
                            _vm.$set(_vm.mappingForm, "targetValue", $$v)
                          },
                          expression: "mappingForm.targetValue"
                        }
                      })
                    ],
                    1
                  ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: "2", size: "mini" },
                    model: {
                      value: _vm.mappingForm.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.mappingForm, "remarks", $$v)
                      },
                      expression: "mappingForm.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini " },
                  on: {
                    click: function($event) {
                      _vm.isShowDialogForm = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }